import React from "react";
import {Typography } from '@material-ui/core';
import FormScopeDefiner from "../../../Component/Forms/FormScopeDefiner";
 
// import useStyles    from '../../Component/Theme_1/ComponentCss';
import ThemeControls from "../../../Component/AllThemesControl";
import contextJson from './masterJson.json';
import fieldsData from './viewTableColumn.json'; 

function Create() {
    const {useStyles} = ThemeControls;
    const classes=useStyles();
    const contextClasses = classes.topSpace;
    const contextObjective = "create";
    const apiContextObj = fieldsData.config;
    let sideImageData={};
    function formatDate(input) {
      if (input.toLowerCase() === "today") {
          // Get today's date
          var today = new Date();
          
          // Get day, month, and year
          var day = today.getDate();
          var month = today.getMonth() + 1; // January is 0, so we add 1
          var year = today.getFullYear();
          
          // Add leading zeros if necessary
          if (day < 10) {
              day = '0' + day;
          }
          if (month < 10) {
              month = '0' + month;
          }
          
          // Format the date as "DD-MM-YYYY"
          var formattedDate = day + '-' + month + '-' + year;
          
          return formattedDate;
      } else {
          // If input is not "today", return null or any other indication as per your requirement
          return null;
      }
  }
    
    Object.keys(contextJson).forEach((key,index) =>{
      if(key!=="xioFEConfig"){
        contextJson[key].fields.map((field)=>{
        if (field.field_default_value) {
            field.field_value = field.field_default_value
            field.id = ""
            field.field_helperText = "";
          }else if (field.field_default_value) {
            field.field_value = field.field_default_value
            field.id = ""
            field.field_helperText = ""
          } else{
            field.field_value = "";
            field.id = "";
            field.field_helperText = "";
          }
          return field; // <-- add this return statement
        });
        
        // =---sideIMage---dataAssing--->
        if(contextJson['xioFEConfig']&&contextJson['xioFEConfig'].sideImageData){
          sideImageData=contextJson['xioFEConfig'].sideImageData;
        }
      }
    });

console.log(contextJson)
    return (
      <div className={classes.main}>
          {/* <PolicyImg Image={smsPolicyImg} data={sideImageData}/>  */}
          <div className={classes.formAline}>
            {/* <Typography variant="h6" className={classes.marginChange}>
              {contextHeading}
            </Typography> */}
          <FormScopeDefiner value={{contextJson,apiContextObj,contextClasses,contextObjective}}>
          </FormScopeDefiner> 
          </div>
      </div>
    )
  }

  export default Create;
  